import React, { Fragment } from "react";
import identity from "../Assets/img/identity.png";
import experienceGraph from "../Assets/img/experience-graph.png";
import locationGraph from "../Assets/img/location-graph.png";
import ITNotIT from "../Assets/img/it-nonit-number.png";
import NonIT from "../Assets/img/nonit-graph.png";
import ITGraph from "../Assets/img/it-graph.png";
import Clients from "../Assets/img/clients.png";
import { useGetEmployerDataQuery } from "../Store/api/CommonApi";

function Employer() {
  const { data, isError } = useGetEmployerDataQuery();

  
  const HiringPrograms = data?.data
    ? data?.data?.event_content[1]?.content
    : [];

    const numberOfSections = Math.ceil(HiringPrograms.length / 2);

    //console.log(HiringPrograms);
    

    //console.log(Math.ceil(data?.data?.event_content[1].content.length/ 2));
    
    //console.log(Math.ceil(HiringPrograms?.content?.length / 2));

  //   const contents = data?.data ? data?.data?.event_content[0]?.content : [];
  //   const wcu_contents = data?.data ? data?.data?.event_content[1]?.content : [];
  //   const videos = data?.data?.event_video || [];
  //   const event_photo = data?.data ? (data?.data?.event_photo) : [];
  //   const sooss_photos = data?.data ? (data?.data?.event_photo) : [];
  //   const hiring_photos = data?.data ? (data?.data?.event_photo) : [];

  return (
    <Fragment>
      {/* HERO */}
      <section className="max-w-6xl mx-auto px-6 py-12 text-center">
         <div dangerouslySetInnerHTML={{ __html: data?.data?.main?.message_1}} className="text-4xl font-bold mb-3"></div>
        {/* <h1 className="text-4xl font-bold mb-3">
          {data?.data?.main?.main_heading || "LGBT+ Talent Landscape (2026)"}
        </h1> */}
        <p className="text-gray-600" className="mb-5">
          {data?.data?.main?.secondry_heading ||
            "Connecting authentic identities with inclusive opportunities"}
        </p>
        <h3 className="text-2xl font-bold mb-3" dangerouslySetInnerHTML={{ __html: data?.data?.main?.main_heading}}></h3>
      </section>
      {/* EXECUTIVE SNAPSHOT */}
      {/* EXPERIENCE GRAPH */}
      <section className="max-w-6xl mx-auto px-6 mb-12">
        <h2 className="text-lg font-semibold mb-3">
          {data?.data?.event_content[0]?.section_name ||
            "Professional Maturity &amp; Experience Levels"}
        </h2>
        <div className="bg-white border rounded-xl p-6 text-center">
          <img
            src={data?.data?.event_content[0]?.image}
            className="mx-auto w-full"
          />
        </div>
        <p className="text-sm text-gray-600 mt-4">
          {data?.data?.event_content[0]?.content[0]}
          {/* <strong>Our talent data speaks for itself:</strong> 46% of the pool
          possess 6+ years of experience, ensuring a high-caliber pipeline for
          your mid &amp; senior-level vacancies. */}
        </p>
      </section>
      <section className="max-w-6xl mx-auto px-6 mb-12">
        <div className="grid md:grid-cols-2 gap-6">
          {/* IT */}
          <div>
            <h2 className="text-lg font-semibold mb-3">
              Validated Identity Spectrum
            </h2>
            <div className="bg-white border rounded-xl p-4 text-center">
              <img src={identity} className="mx-auto" />
            </div>
          </div>
          {/* NON IT */}
          <div>
            <h2 className="text-lg font-semibold mb-3">
              Footprint &amp; Talent Density
            </h2>
            <div className="bg-white border rounded-xl p-4 text-center">
              {" "}
              <img src={locationGraph} className="mx-auto" />{" "}
            </div>
          </div>
        </div>
      </section>
      {/* TALENT SPLIT */}
      <section className="max-w-6xl mx-auto px-6 mb-12">
        <h2 className="text-lg font-semibold mb-3">
          The Talent Split: Technology vs. Business functions
        </h2>
        <div className="bg-white border rounded-xl p-6 text-center">
          {" "}
          <img src={ITNotIT} className="mx-auto w-full max-w-3xl" />{" "}
        </div>
      </section>
      {/* SKILLS */}
      <section className="max-w-6xl mx-auto px-6 mb-12">
        <div className="grid md:grid-cols-2 gap-6">
          {/* NON IT */}
          <div>
            <h2 className="text-lg font-semibold mb-3">
              Business &amp; Functional Expertise (Non-IT)
            </h2>
            <div className="bg-white border rounded-xl p-4 text-center">
              {" "}
              <img src={NonIT} className="mx-auto" />{" "}
            </div>
          </div>
          {/* IT */}
          <div>
            <h2 className="text-lg font-semibold mb-3">
              Technical Competency Radar (IT Skills)
            </h2>
            <div className="bg-white border rounded-xl p-4 text-center">
              {" "}
              <img src={ITGraph} className="mx-auto" />{" "}
            </div>
          </div>
        </div>
      </section>
      {/* PROGRAMS */}
      <section className="max-w-6xl mx-auto px-6 mb-12">
         { HiringPrograms?.section_name ? (<h2 className="text-lg font-semibold mb-3" dangerouslySetInnerHTML={{ __html: HiringPrograms?.section_name }}></h2>) : (<h2 className="text-lg font-semibold mb-3" dangerouslySetInnerHTML={{ __html: `Our Hiring Programs<p style="font-weight: normal;">Tailored solutions to hire LGBT+ and Women talent</p>` }}></h2>)}
        {/* <h2 className="text-2xl font-semibold mb-8">
          {HiringPrograms?.section_name ||
            "Our Hiring Programs<br>Tailored solutions to hire LGBT+ and Women talent"}
        </h2> */}
        <div className="grid md:grid-cols-3 gap-6">
          {Array.from({
            length: numberOfSections,
          }).map((_, index) =>{
            const dataIndex = index * 2;
            const firstItem = HiringPrograms[dataIndex];
            const secondItem =
              HiringPrograms[dataIndex + 1] !== undefined
                ? HiringPrograms[dataIndex + 1]
                : "";
            return (
            <div key={index} className="bg-white p-6 rounded-2xl shadow">
              <h3 className="font-semibold mb-2">{firstItem}</h3>
              <p className="text-sm text-gray-600">{secondItem}</p>
            </div>
          )})}
          {/* <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">Pride Circle Jobs Portal</h3>
            <p className="text-sm text-gray-600">
              {" "}
              Pay as you go model, where you subscribe to 'X' number of job
              postings &amp; 'Y' number of resume access along with branding on
              our portal and social media{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">Rainbow Hiring Drive</h3>
            <p className="text-sm text-gray-600">
              {" "}
              Initiative where we support companies with sourcing relevant LGBT+
              candidates based on JDs along with a Digital Campaign leading to a
              One Day Drive{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">100 Queer Intern</h3>
            <p className="text-sm text-gray-600">
              {" "}
              A transformative program enabling young LGBT+ talent gain
              meaningful work experience &amp; earn a stipend while building
              career pathways.{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">SheRISE Internship</h3>
            <p className="text-sm text-gray-600">
              {" "}
              Focused internship program empowering Women Talent gain hands-on
              industry experience with companies that value inclusion &amp;
              gender equity.{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">
              Masterclass – Skilling &amp; Hiring
            </h3>
            <p className="text-sm text-gray-600">
              {" "}
              Customized sessions for companies to interact, coach &amp; hire
              Women &amp; LGBT+ talent. Organized in Virtual &amp; In-Person
              formats.{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">Rainbow Mixer</h3>
            <p className="text-sm text-gray-600">
              {" "}
              Event bridging LGBT+Talent &amp; inclusive employers to spark
              conversations on careers and culture.{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">Inclusive Hiring Workshop</h3>
            <p className="text-sm text-gray-600">
              {" "}
              Designed to help Hiring Managers &amp; TA teams understand the
              importance of integrating LGBT+ Talent into every stage of the
              employee lifecycle.{" "}
            </p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow">
            <h3 className="font-semibold mb-2">RISE Job Fair</h3>
            <p className="text-sm text-gray-600">
              {" "}
              India's premier &amp; biggest LGBT+ Job Fair where inclusive
              companies meet &amp; hire LGBT+ Talent. Organized in Virtual &amp;
              In-Person formats.{" "}
            </p>
          </div> */}
        </div>
      </section>
      {/* TRUSTED LEADERS */}
      <section className="max-w-6xl mx-auto px-6 mb-16">
        <h2 className="text-lg font-semibold mb-3">
          {" "}
          Trusted by Industry Leaders
          <p style={{ fontWeight: "normal" }}>
            Enabling LGBT+ &amp; Women hiring across 100+ partner organizations.
          </p>
        </h2>
        <div className="bg-white border rounded-xl py-8 overflow-hidden">
          {" "}
          <img src={Clients} className="mx-auto" alt="" />{" "}
        </div>
      </section>
      {/* CTA */}
      <section className="bg-indigo-600 text-white py-12 text-center">
        <h2 className="text-white text-2xl mb-3">Want to learn more?</h2>
        <p>Email us at ananya@thepridecircle.com</p>
      </section>
    </Fragment>
  );
}

export default Employer;
